import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import type {
  UpdateZapCapAlertConfigPayload,
  ZapCapBalance,
  ZapCapUserUsageResponse,
} from "./types";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/zapcap-balance`;

export async function getZapCapBalance(): Promise<ZapCapBalance> {
  const headers = await getAuthHeader();
  const response = await axios.get<ZapCapBalance>(`${BASE}/current`, {
    headers,
  });
  return response.data;
}

export async function updateZapCapAlertConfig(
  payload: UpdateZapCapAlertConfigPayload,
): Promise<ZapCapBalance> {
  const headers = await getAuthHeader();
  const response = await axios.put<ZapCapBalance>(`${BASE}/config`, payload, {
    headers,
  });
  return response.data;
}

export async function getZapCapUserUsage(): Promise<ZapCapUserUsageResponse> {
  const headers = await getAuthHeader();
  const response = await axios.get<ZapCapUserUsageResponse>(
    `${BASE}/user-usage`,
    { headers }
  );
  return response.data;
}

export async function refreshZapCapBalance(): Promise<ZapCapBalance> {
  const headers = await getAuthHeader();
  const response = await axios.post<ZapCapBalance>(
    `${BASE}/refresh`,
    {},
    { headers },
  );
  return response.data;
}
